








import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import TrendCard from "@/components/core/nodes/partials/TrendCard.vue";
import StatisticLineChart from "@/components/core/chart/StatisticLineChart.vue";
import RadialChart from "@/components/layout/charts/radial/RadialChart.vue";
import { StatisticModule } from "@/store/modules/StatisticModule";
import { resolveModule } from "@/store";

@Component({
  components: {
    "trend-card": TrendCard,
    "radial-chart": RadialChart,
    "statistic-line-chart": StatisticLineChart,
  },
})
export default class StatisticTrendCard extends Vue {

  @Prop()
  private readonly stats!: string;

  @Prop({
    required: false,
    type: String,
    default: "",
  })
  private readonly title!: string;

}
